import { remove as removeCookie, set as setCookie } from 'js-cookie';
import * as React from 'react';

import { webConfig } from '@gitbook/env';

import { useNavigationState } from '../../navigation';
import { apiClient } from '../api';
import { useCurrentOrganizationId } from '../organization';

const VISITOR_CLAIMS_TOKEN = 'gitbook-visitor-token';

/**
 * Updates a members's lastSeenAt, fire and forget, on each navigation screen change.
 */
export function useUpdateOrgMemberLastSeenAt() {
    const { screen } = useNavigationState();
    const organizationId = useCurrentOrganizationId();

    React.useEffect(() => {
        if (!organizationId || process.env.GITBOOK_PREDICTABLE_UI) {
            return;
        }

        const updateOrgMemberLastSeenAt = async () => {
            let shouldRemoveCookie = false;

            try {
                const { data } =
                    await apiClient.organizationMembers.updateOrganizationMemberLastSeenAt(
                        organizationId
                    );

                const { gitbookVisitorClaims } = data;

                if (!gitbookVisitorClaims || !webConfig.gitbook.adaptiveContentCookieDomain) {
                    shouldRemoveCookie = true;
                } else {
                    setCookie(VISITOR_CLAIMS_TOKEN, gitbookVisitorClaims, {
                        domain: webConfig.gitbook.adaptiveContentCookieDomain,
                    });
                }
            } catch (_err) {
                shouldRemoveCookie = true;
            }

            if (shouldRemoveCookie) {
                removeCookie(VISITOR_CLAIMS_TOKEN);
            }
        };

        // We "fire and forget" the API request, and don't care about the outcome.
        updateOrgMemberLastSeenAt();
    }, [
        organizationId,
        // To rerun the effect on each navigation change
        screen,
    ]);
}
